'use strict';

/*global app*/
/*global services*/
/*global initialize*/
/*global nl2br*/
/*global normalizeInput*/
/*global createObjectCallBack*/
/*global invokeCallback*/
/*global resClose*/
/*global resSuccess*/

function InputService() {
  this.modal = null;
  this.keyboard = null;
  this.keyboardVisible = true;
  this.value = '';

  this.init();
}

InputService.prototype = $.extend({}, {
  constructor: 'InputService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    return _this;
  },

  //----------------------------------------------------------------------------

  enter: function enter(data) {
    var _this = this;

    if (_this.keyboardVisible) {
      _this.value = _this.keyboard.getValue();
    } else {
      _this.value = _this.modal.contentDOM().find('input').val();
    }

    _this.value = _this.value.replace(/\0/g, '');
    _this.value = _this.value.replace(RegExp(String.fromCharCode(29), 'g'), ' ');

    _this.modal.close(function () {
      invokeCallback(data.callback, resSuccess, _this.value);
    });

    return _this;
  },

  getValueWithRes: function getValueWithRes(data, callback) {
    var _this = this;

    _this.value = null;

    data = normalizeInput(data);
    data.callback = callback;

    var content = data.content || '';

    if (data.asHtml && content) {
      content = '<p class="text-center">' + nl2br(content) + '</p>';
    }

    _this.modal.empty().open({
      title: data.title,
      saveBtnTitle: app.t('form.insert'),
      height: 'auto',
      width: 'md',
      submitCallBack: createObjectCallBack(_this, 'enter', data),
      enterSubmitCallBack: createObjectCallBack(_this, 'enter', data),
      form: true,
      keyboardClose: false,
      focusInput: true,
      content: content + '<div class="keyboard-wrapper"></div>',
      openCallBack: function () {
        _this.modal.setFocus();
      },

      closeCallBack: function () {
        invokeCallback(data.callback, resClose);
      }
    });

    _this.modal.contentDOM().find('.keyboard-wrapper').append(_this.keyboard.getKeyboard());

    _this.keyboard.reset();
    _this.keyboard.setVirtualFocus();
    _this.keyboard.setIsAllowedSwitchLayout(true);

    if ('value' in data) {
      _this.keyboard.setValue(data.value);
    }

    if ('suffix' in data) {
      _this.keyboard.setInputSuffix(data.suffix);
    }

    if ('placeholder' in data) {
      _this.keyboard.setPlaceholder(data.placeholder);
    }

    _this.keyboardVisible = true;

    return _this;
  },

  getValue: function getValue(data, callback) {
    var _this = this;

    return _this.getValueWithRes(data, function (res, resData) {
      if (res === resSuccess) {
        invokeCallback(callback, resData);
      }
    });
  },

  scanValueWithRes: function scanValueWithRes(data, callback) {
    var _this = this;

    _this.value = null;

    data = normalizeInput(data);
    data.callback = callback;

    var content = data.content || '';

    if (data.asHtml && content) {
      content = '<p class="text-center">' + nl2br(content) + '</p>';
    }

    _this.modal.empty().open({
      title: data.title,
      saveBtnTitle: app.t('form.insert'),
      height: 'auto',
      width: 'md',
      submitCallBack: createObjectCallBack(_this, 'enter', data),
      enterSubmitCallBack: createObjectCallBack(_this, 'enter', data),
      form: true,
      keyboardClose: false,
      focusInput: true,
      content: content + '<div><input class="form-control k2-keyboard-input--lazy-open" /></div>',
      openCallBack: function () {
        initialize(_this.modal.contentDOM());
        _this.modal.setFocus();
      },

      closeCallBack: function () {
        invokeCallback(data.callback, resClose);
      }
    });

    _this.keyboardVisible = false;

    return _this;
  },

  scanValue: function scanValue(data, callback) {
    var _this = this;

    return _this.scanValueWithRes(data, function (res, resData) {
      if (res === resSuccess) {
        invokeCallback(callback, resData);
      }
    });
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.modal = services.get('modal-input');
    _this.keyboard = services.get('keyboard');

    _this.registerCallbacks();

    return _this;
  }
});
